import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(3),
    gap: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      width: '88%',
      gap: 0,
      flexDirection: 'row',
      margin: '0 auto',
      justifyContent: 'space-between'
    }
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      width: 430
    }
  },
  input: {
    marginBottom: theme.spacing(),
    '& fieldset': {
      backgroundColor: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.main,
      borderRadius: 3,
      minHeight: 45
    },

    '& label': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      backgroundColor: theme.palette.primary.contrastText,
      paddingRight: theme.spacing()
    },
    '& input': {
      zIndex: 1,
      fontWeight: 500
    },
    '& > p': {
      color: theme.palette.secondary.contrastText
    },

    '&.multiline': {
      '& textarea': {
        zIndex: 1,
        fontWeight: 500,
        '&::-webkit-scrollbar': {
          width: 12,
          [theme.breakpoints.up('md')]: {
            width: 16
          }
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 5px grey',
          borderRadius: 10,
          backgroundColor: theme.utils.rgba(theme.palette.primary.main, 0.2)
        },
        /* Handle */
        '&::-webkit-scrollbar-thumb': {
          borderRadius: 10,
          background: theme.utils.rgba(theme.palette.primary.main, 0.45)
        }
      }
    }
  },
  altTooltipButton: {
    right: '5px !important',
    top: '24px !important',

    [theme.breakpoints.up('md')]: {
      top: '4px !important'
    }
  },

  combo: {
    '& > div > label': {
      transform: 'translate(14px, 10px) scale(1)'
    },
    '& > div > div': {
      paddingBottom: `0 !important`,
      paddingTop: `0 !important`,
      paddingLeft: `${theme.spacing()} !important`,
      paddingRight: `${theme.spacing()} !important`
    },
    '& > div > div > div': {
      zIndex: 2
    },
    '& svg': {
      color: theme.palette.primary.main
    }
  },

  tooltip: {
    backgroundColor: theme.palette.tooltip.main,
    width: 180,
    maxWidth: 180,
    padding: `${theme.spacing(1, 2)} !important`
  },
  tooltipButton: {
    right: '25px !important',
    top: '2px !important',
    [theme.breakpoints.up('md')]: {
      right: '2px !important',
      top: '2px !important'
    }
  },
  tooltipArrow: {
    color: theme.palette.tooltip.main
  },
  alertTooltip: {
    backgroundColor: theme.palette.tooltip.light,
    width: 240,
    maxWidth: 240,
    fontSize: '.75rem',
    padding: `${theme.spacing(1, 2)} !important`
  },
  altTooltipArrow: {
    color: theme.palette.tooltip.light
  },
  tooltipLink: {
    color: theme.palette.primary.contrastText
  },
  tooltipTitle: {
    fontSize: '.75rem'
  },
  alertButton: {
    zIndex: 1000,
    '& svg': {
      color: theme.palette.tooltip.light
    }
  },
  disciplinesContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '& > div': {
      width: '100%'
    },

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row'
    }
  },
  option: {
    zIndex: '2 !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 500,
    color: theme.palette.secondary.contrastText,
    margin: theme.spacing(1, 0)
  },
  infoButton: {
    alignSelf: 'flex-end',
    marginTop: -theme.spacing(4),

    [theme.breakpoints.up('lg')]: {
      alignSelf: 'flex-start',
      marginTop: theme.spacing(),
      marginBottom: 0,
      marginRight: -theme.spacing(5)
    }
  },

  inputDatePicker: {
    margin: 0,
    minWidth: 120,

    '& input': {
      height: 4,
      backgroundColor: theme.palette.primary.contrastText,
      fontWeight: 500,
      fontSize: '.9rem'
    },
    '& fieldset': {
      height: 45,
      padding: theme.spacing(1.1, 1.8),

      borderColor: theme.palette.primary.main,
      borderRadius: 3
    },
    '& svg': {
      color: theme.palette.primary.main
    },
    '& label': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      transform: 'translate(14px, 11px) scale(1)',
      backgroundColor: theme.palette.primary.contrastText,
      paddingRight: theme.spacing(2.25)
    },
    '& > div > div': {
      marginLeft: 0
    },
    '& div > button': {
      width: 40,
      height: 40,
      borderRadius: 0,
      backgroundColor: theme.palette.primary.contrastText,
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.contrastText,
        color: theme.palette.primary.main
      }
    },
    '& > div': {
      paddingRight: 0,
      height: 40
    },
    [theme.breakpoints.up('sm')]: {
      width: 150
    }
  },
  pickers: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(2),
    gap: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: theme.spacing(2)
    }
  },
  altErrorMessage: {
    fontSize: '.75rem'
  },
  datePickerFormGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5)
  },
  select: {
    height: 40,
    width: '100%',
    backgroundColor: theme.palette.primary.contrastText,
    '& > div': {
      padding: theme.spacing(1, 1.75),
      paddingTop: theme.spacing(0.5),
      fontWeight: 500
    },
    '& input': {
      height: 3,
      color: theme.palette.primary.main
    },
    '& fieldset': {
      height: 45,
      borderColor: theme.palette.primary.main,
      borderRadius: 5
    },
    '& svg': {
      color: theme.palette.primary.main,
      height: 19
    }
  },
  labelSelect: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    paddingRight: theme.spacing(),
    backgroundColor: theme.palette.primary.contrastText,
    transform: 'translate(14px, 13px) scale(1)',

    '&.error': {
      color: '#f44336'
    }
  },
  errorMessage: {
    paddingLeft: theme.spacing(2)
  },
  otherContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    margin: theme.spacing(1, 0),
    [theme.breakpoints.up('lg')]: {
      alignItems: 'center',
      flexDirection: 'row'
    }
  },
  numberLabel: {
    flexShrink: 0,
    fontSize: '.875rem'
  },
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  switchTitle: {
    fontSize: '.875rem'
  },
  distanceAwardContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing()
  }
}))
